import ApiService from '../../service/apiService.js';
const querystring = require('querystring')
const entity='acc'
var AccountService = {

    findAll: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "accounts"
            $options.method = "get"

            if ($data) {
                $options.url = "accounts?" + querystring.stringify($data)
                console.log($options.url)
            }
            ApiService.request($options,entity,'view')
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });

    },
    getAccountByIssue: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "getAccountByIssue"
            $options.method = "get"

            if ($data) {
                $options.url = "getAccountByIssue?" + querystring.stringify($data)
                console.log($options.url)
            }
            ApiService.request($options,entity,'view')
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });

    },
  
    findOne: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "accounts/" + $data
            console.log($options.url)
            $options.method = "get"
            if (!$data) {
                $options.data = $data
            }
            ApiService.request($options,entity,'view')
                .then(response => {
                    // console.log('Gpt the data');
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error);
                })
        });

    },
    update: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.data = $data
            $options.url = "accounts/" + $data.id;
            $options.method = "post"
            console.log($options)
            ApiService.request($options,entity,'update')
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        })
    },
    save: function($data) {
        return new Promise(function(resolve, reject) {
            var $options = {};
            $options.data = $data
            $options.url = "accounts" + $data.id;
            $options.method = "post"
            console.log($options)
            ApiService.request($options,entity,'update')
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        });
    },

    create: function($data) {
        return new Promise(function(resolve, reject) {
            var $options = {};
            $options.data = $data
            $options.url = "accounts";
            $options.method = "post"
            console.log($options)
            ApiService.request($options,entity,'create')
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        });
    }
};
export default AccountService;